module.exports = __webpack_public_path__ + "img/appAsset-brand--dian.0393b22b.svg";